<template>
  <div>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options">
      <a slot="sujet" slot-scope="props" href="#" @click.prevent="showFiche(props.row.id)">{{ props.row.sujet }}</a>  
      <div slot="message" slot-scope="props">
        <span :id="'identifiant-tooltip' + props.row.id" >{{ props.row.message.substring(0,50) }}</span>
        <b-tooltip :target="'identifiant-tooltip' + props.row.id" triggers="hover" placement="top">{{ props.row.message }}</b-tooltip>
      </div>

      <div v-if="props.row.id_pp" slot="id_pp" slot-scope="props" class="slot-number">
        <span>{{ props.row.id_pp }}</span>
      </div>

      <div v-if="props.row.nir" slot="nir" slot-scope="props" class="slot-number">
          <span>{{ formatNir(props.row.nir) }}</span>
      </div>

      <div v-if="props.row.created_at" slot="created_at" slot-scope="props" class="slot-date">
        <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
      </div>
    </v-server-table>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from "../utils/auth";

export default {
  name: "ContactTable",
  props: ["tableEntry"],
  data() {
    let self = this;
    return {
      url: '',
      columns: ["created_at", "id_pp", "nir", "nom", "prenom", "sujet", "message"],
      items: [],
      sujets : [],
      options: {
        headings: {
          "created_at": "Date création",
          "id_pp" : "N°Identifiant NSI",
          "nir" : "N° Sécu. Soc.",
          "nom" : 'Nom',
          "prenom" : 'Prénom',
          sujet: "Sujet",
          message: "Message"
        },
        sortable: ["sujet"],
        filterable: false,
        perPage: 10,
        perPageValues: [10, 25, 50],
        texts: {
          filterPlaceholder: "N°Identifiant NSI, Sujet"
        },
        orderBy: { ascending: true},
        requestFunction: function (data) {
            self.url = '/espaceBeneficiaire/contacts/recherche'
            data["idpp_criteria"] = self.tableEntry.idpp_criteria;
            data["dossier_criteria"] = self.tableEntry.dossier_criteria;
            data["nir_criteria"] = self.tableEntry.nir_criteria;
            data["sujet"] = self.tableEntry.sujet;
            data["nom"] = self.tableEntry.nom;
            data["prenom"] = self.tableEntry.prenom;
            data["noSearch"] = self.$parent.noSearch

            self.$store.commit("IS_LOADING", true);

            return axios.get(self.url, {
                params: data
            })
            .catch(function (e) {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                showConfirmButton: false,
                timer: 5000
              });
            }.bind(this));
        }
      },
      user: []
    };
  },
  methods: {
    onLoaded(){
      this.$store.commit("IS_LOADING", false);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      return date;
    },
    showFiche(contactId) {
      // this.$router.push({ path: '/espace-beneficiaire/gestion-des-contacts/' + contactId })
      this.$router.push({ path: "/espace-beneficiaire/gestion-des-contacts/" + contactId, query: { in: this.tableEntry.idpp_criteria, do: this.tableEntry.dossier_criteria, ns: this.tableEntry.nir_criteria, no: this.tableEntry.nom, pr: this.tableEntry.prenom, su: this.tableEntry.sujet }})
    },
    formatNir(textNir) {
      if(textNir !== null  && textNir !== ''){

        let nirs = textNir.split(',');
        let displayNir = '';

        nirs.forEach(function (element){
          if(element.length > 13){
            if(displayNir === ''){
              displayNir = element.substring(0,13);
            }else{
              displayNir = displayNir + '\n' + element.substring(0,13);
            }
          }
        });
        return displayNir;
      }else{
        return textNir;
      }
    }
  }
};
</script>

<style scoped>
.VueTables__search-field input {
  width: 240px !important; 
}
</style>